<script>
  import { router } from '@inertiajs/svelte'
  
  let { alert = '', proceed_to_url = '' } = $props();
  
  let password = $state('');
  
  function submit(event) {
    event.preventDefault();
    router.post('/sessions/sudo', {
      password,
      proceed_to_url
    });
  }
</script>

<div class="sudo-container">
  {#if alert}
    <p class="alert">{alert}</p>
  {/if}

  <h1>Enter your password to continue</h1>

  <form onsubmit={submit}>
    <input type="hidden" name="proceed_to_url" value={proceed_to_url} />

    <div class="form-group">
      <!-- svelte-ignore a11y_autofocus -->
      <input 
        type="password" 
        bind:value={password} 
        required 
        autofocus 
        autocomplete="current-password"
        placeholder="Password"
        class="password-input"
      />
    </div>

    <div class="form-group">
      <button type="submit" class="continue-button">Continue</button>
    </div>
  </form>

  <br>

  <div class="info-box">
    <p>
      <strong>Why are you asking me to do this?</strong><br>
      To better protect your account, we'll occasionally ask you to confirm your password before performing sensitive actions.
    </p>
  </div>

  <div class="info-box">
    <p>
      <strong>Forgot your password?</strong><br>
      We'll help you <a href="/identity/password_resets/new">reset it</a> so you can continue.
    </p>
  </div>
</div>

<style>
  .sudo-container {
    max-width: 500px;
    margin: 0 auto;
    padding: 2rem 1rem;
  }
  
  .alert {
    color: red;
    margin-bottom: 1rem;
  }
  
  h1 {
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
  }
  
  .form-group {
    margin-bottom: 1rem;
  }
  
  .password-input {
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #d1d5db;
    border-radius: 0.375rem;
    font-size: 1rem;
  }
  
  .continue-button {
    background-color: #047857;
    color: white;
    border: none;
    padding: 0.75rem 1.5rem;
    border-radius: 0.375rem;
    font-weight: 500;
    cursor: pointer;
    font-size: 1rem;
  }
  
  .continue-button:hover {
    background-color: #065f46;
  }
  
  .info-box {
    background-color: #f3f4f6;
    padding: 1rem;
    border-radius: 0.375rem;
    margin-bottom: 1rem;
  }
  
  .info-box p {
    margin: 0;
    line-height: 1.5;
  }
  
  .info-box a {
    color: #047857;
    text-decoration: none;
  }
  
  .info-box a:hover {
    text-decoration: underline;
  }
</style>